module.exports = __webpack_public_path__ + "static/media/cat-lights.506f26ad.svg";